<template>
    <div>
        <span v-html="$t('notification.chatbotRestored', {user: $_.get(activity, 'actorUser.name'), chatbot: $_.get(activity, 'payload.name') })"></span>
    </div>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
    name: "ChatbotRestored",
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
});
</script>

<style scoped lang="scss"></style>

